import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthEnum } from "../../types/enum.types";


export interface AuthInterface {
  userId: any;
  accessToken: any;
  accessTokenExpiration: any;
  role?: any;
}

const initialState: AuthInterface = {
  userId: localStorage.getItem(AuthEnum.userId) || null,
  accessToken: localStorage.getItem(AuthEnum.accessToken) || null,
  role: localStorage.getItem(AuthEnum.role) || null,
  accessTokenExpiration:
    localStorage.getItem(AuthEnum.accessTokenExpiration) || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action: PayloadAction<AuthInterface>) {
      const { accessToken, accessTokenExpiration, userId, role } =
        action.payload;
      state.accessToken = accessToken;
      state.accessTokenExpiration = accessTokenExpiration;
      state.userId = userId;
      state.role = role;
      localStorage.setItem(AuthEnum.accessToken, accessToken);
      localStorage.setItem(AuthEnum.userId, userId);
      if (role) {
        localStorage.setItem(AuthEnum.role, role);
      }
      localStorage.setItem(
        AuthEnum.accessTokenExpiration,
        accessTokenExpiration
      );
    },
    getReferralCode(state, action: PayloadAction<string>) {
      const referralCode = action.payload;
      localStorage.setItem(AuthEnum.referralCode, referralCode);
    },
    logout(state) {
      localStorage.removeItem(AuthEnum.accessToken);
      localStorage.removeItem(AuthEnum.userId);
      localStorage.removeItem(AuthEnum.role);
      localStorage.removeItem(AuthEnum.accessTokenExpiration);
      // Use immer to safely update the state
      return {
        ...state,
        userId: null,
        accessToken: null,
        role: null,
        accessTokenExpiration: null,
      };
    },
  },
});

export const { login, logout, getReferralCode } = authSlice.actions;
export default authSlice.reducer;
